import clsx from "clsx";
import TabsModalFooter from "ui/common/components/feedback/TabsModal/TabsModalFooter/TabsModalFooter";
import Form from "ui/common/components/input/Form/Form";
import useTranslate from "ui/locale/hooks/useTranslate";
import { UpdateCaducityNames, UpdateCaducityState } from "./UpdateCaducityModal.types";
import useSetTabsState from "ui/common/components/feedback/TabsModal/hooks/useSetTabsState";
import useGoToNextTab from "ui/common/components/feedback/TabsModal/hooks/useGoToNextTab";
import useGetPointCaducity from "ui/point/query/useGetPointCaducity";
import useCloseTabModal from "ui/common/components/feedback/TabsModal/hooks/useCloseTabModal";
import { IconButtonRoot, MainRow, NumericTextFieldRoot, PencilIconRoot } from "./UpdateCaducityModal.styles";
import Callout from "ui/common/components/feedback/Callout/Callout";

export interface SetCaducityTabProps {
    className?: string;
    style?: React.CSSProperties;
}

export default function SetCaducityTab({ className, ...rest }: SetCaducityTabProps) {
    const translate = useTranslate();
    const { data: defaultCaducityDays = 30 } = useGetPointCaducity();
    const setTabState = useSetTabsState<UpdateCaducityState>();
    const goToNextTab = useGoToNextTab();
    const closeModal = useCloseTabModal();

    function handleSubmit({ caducity }: UpdateCaducityState) {
        setTabState({ caducity: Number(caducity) });
        goToNextTab();
    }

    function onEditButtonClick() {
        const inputElement = document.querySelector(`[placeholder="${translate("introduceCaducityDays")}"]`) as HTMLInputElement;
        if (inputElement?.value) {
            const caducity = Number(inputElement.value);
            if (caducity > 0) {
                handleSubmit({ caducity });
            }
        }
    }
    return (
        <Form className={clsx("set-caducity-tab", className)} onSubmit={handleSubmit} {...rest}>
            <Callout icon={false} status="success" text={translate("caducityModaleExplanation")} />
            <MainRow>
                <NumericTextFieldRoot
                    name={UpdateCaducityNames.CADUCITY}
                    label={translate("caducity")}
                    placeholder={translate("introduceCaducityDays")}
                    defaultValue={Number(defaultCaducityDays).toString()}
                    required
                    validators={{ gt: 0 }}
                    suffix={translate("days")}
                    maxDecimals={0}
                    readonly
                />
                <IconButtonRoot style={{ position: "relative" }} onClick={onEditButtonClick}>
                    <PencilIconRoot viewBox="0 0 32 32" />
                </IconButtonRoot>
            </MainRow>
            <TabsModalFooter mainLabel={translate("save")} onSubmit={closeModal} />
        </Form>
    );
}
